import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDarkMode } from './DarkModeContext';
import Footer from './Footer';

function Founder() {
    const { darkMode } = useDarkMode();

    return (
        <>
            <Helmet>
                <title>Boukar Sall – Founder of Merra AI</title>
                <meta name="description" content="The story of Boukar Sall, founder of Merra AI. From Oracle to Plaiz, advising 100+ founders, to building the future of short-form video creation." />
                <link rel="canonical" href="https://www.merra.ai/founder" />
                <meta property="og:title" content="Boukar Sall – Founder of Merra AI" />
                <meta property="og:url" content="https://www.merra.ai/founder" />
            </Helmet>
            <div style={{
                maxWidth: '720px',
                margin: '0 auto',
                padding: '24px 20px 48px',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                lineHeight: 1.7,
                color: darkMode ? '#e0e0e0' : '#333',
                backgroundColor: darkMode ? '#1a1a1a' : 'white',
                minHeight: '100vh'
            }}>
                <div style={{ marginBottom: '32px' }}>
                    <Link
                        to="/"
                        style={{
                            color: darkMode ? '#4A9EFF' : '#1976d2',
                            textDecoration: 'none',
                            fontSize: '15px'
                        }}
                    >
                        ← Back to Home
                    </Link>
                </div>

                <h1 style={{
                    color: darkMode ? '#fff' : '#1a1a1a',
                    borderBottom: `2px solid ${darkMode ? '#AB5898' : '#AB5898'}`,
                    paddingBottom: '12px',
                    marginBottom: '32px',
                    fontSize: 'clamp(1.5rem, 4vw, 2rem)'
                }}>
                    Founder
                </h1>

                <p style={{ fontSize: '17px', marginBottom: '24px' }}>
                    My name is Boukar Sall, and I'm the founder of Merra AI, and here's my story.
                </p>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    I've been in tech for the past 10 years.
                    After Oracle, I started a company, a fashion social network called Plaiz.
                    The company grew to 50,000 users and got acquired after 5 years.
                    Between that and today, I advised more than 100 founders on how to go from idea to validation to revenue fast, and worked for various startup studios.
                </p>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    Until I decided to work on a problem I was obsessed with.
                </p>

                <h2 style={{
                    fontSize: '1.35rem',
                    fontWeight: 700,
                    color: darkMode ? '#fff' : '#1a1a1a',
                    marginTop: '32px',
                    marginBottom: '16px'
                }}>
                    We are living in a distribution economy.
                </h2>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    And yet, the way we create content is broken.
                    I've edited videos since high school, manually trimming milliseconds on a timeline.
                    It evolved from Premiere Pro to Capcut, but the only change was going from desktop to mobile.
                    But in the age of AI, change is inevitable.
                </p>

                <h2 style={{
                    fontSize: '1.35rem',
                    fontWeight: 700,
                    color: darkMode ? '#fff' : '#1a1a1a',
                    marginTop: '32px',
                    marginBottom: '16px'
                }}>
                    Manual video editing will disappear.
                </h2>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    As the internet is being flooded with AI generated content, I believe we should focus on reel content, and edit it faster.
                    A bunch of tools out there already help you turn long-form videos into short-form clips or edit videos with AI and prompting.
                </p>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    But the storytelling + b-roll format is still underserved. Especially when you want to use your own b-rolls (instead of AI-generated).
                </p>

                <h2 style={{
                    fontSize: '1.35rem',
                    fontWeight: 700,
                    color: darkMode ? '#fff' : '#1a1a1a',
                    marginTop: '32px',
                    marginBottom: '16px'
                }}>
                    What We're building
                </h2>

                <p style={{ fontSize: '16px', marginBottom: '24px' }}>
                    Merra AI automates the creation of your short-form storytelling videos.
                    You upload raw clips, it writes, edits, voices, captions, and you post (or you let it post).
                    I've been using it to grow my audience, obsessing over the growth and retention metrics of my videos, and improving the tool to make the videos better and the process easier.
                </p>

                <p style={{ fontSize: '16px', marginBottom: '8px' }}>
                    I share my journey here:{' '}
                    <a
                        href="https://x.com/boukar_sall"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: darkMode ? '#4A9EFF' : '#1976d2',
                            textDecoration: 'underline',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}
                    >
                        x.com/boukar_sall
                        <ExternalLink size={14} />
                    </a>
                </p>
            </div>
            <Footer />
        </>
    );
}

export default Founder;
